<template>
    <div class="token-share">
        <div class="bg"></div>
        <img src="../assets/share_title.png" class="share-title" >
        <div class="main-content">
            <h3>我在TokenPocket上发行了{{amount}}枚 {{symbol}}</h3>

            <div class="apply-form" v-if="isApply">
                <mu-text-field @input="inputNickname" :maxLength="10" :errorText="nicknameInputErrorText" hintText="昵称" v-model="nickName"/><br/>
                <mu-text-field @input="inputAddress" :maxLength="42" :errorText="addressInputErrorText" :hintText="hintText" v-model="address"/><br/>
                <mu-raised-button class="black-btn" @click="goGetCandy" label="申请领取糖果" primary/>
            </div>

            <p v-if="isApply">还没有钱包地址? 赶快去下一个TokenPocket！<a target="_blank" href="https://www.mytokenpocket.vip">点击访问官网立即下载>></a></p>
            <p v-else>下载TokenPocket查看 <a target="_blank" href="https://www.mytokenpocket.vip">点击访问官网立即下载>></a></p>
        </div>
        <div style="font-size:0">
            <img src="../assets/token-f1.png" style="width:100%">
        </div>
        <div class="tokenpocket-link">
            <img class="i-want-token" src="../assets/token-f2.png" >
            <p>区块链时代人人都应该有属于自己的Token！你还在等什么？ 快来TokenPocket 发行自己的Token吧！</p>
            <mu-raised-button class="black-btn" @click="goGetTP" label="立即发行我的Token" fullWidth primary/>
            <div class="apply-list" v-if="isApply">
                <div class="apply-divider" >
                    <img src="../assets/token-f3.jpg">
                </div>
                <img src="../assets/token-f4.png" class="applied-list-img" alt="">
           
                <div class="apply-item" v-for="item in applyList" :key="item.hid">
                    <h4>{{item.nick_name}} <span class="apply-time">{{item.create_time}}</span></h4>
                </div>
            </div>
        </div>
        
        <div class="footer">

        </div>

        <mu-dialog :open="dialog" title="申请领取成功">
            申请成功～敬请等待金主大大发糖果～
            <mu-flat-button label="确定" slot="actions" primary @click="close"/>
        </mu-dialog>
    </div>
</template>

<script>

import u from 'underscore';
import Axios from 'axios';
import $ from 'jquery';
import moment from 'moment';
import Web3 from 'web3';

const DOMAIN = 'https://preserver.mytokenpocket.vip';

export default {
    name: 'TokenShare',
    data () {
        return {
            token: {},
            nickName: '',
            applyList: [],
            contractAddress: '',
            isApply: false,
            address: '',
            amount: 0,
            symbol: '',
            dialog: false,
            hintText: '',
            addressInputErrorText: '',
            nicknameInputErrorText: '',
            addressVaild: false,
            nameValid: false
        }
    },
    created() {
        window.web3 = new Web3(new Web3.providers.HttpProvider("https://eth10xie2vce3mhh.jccdex.cn"));
        
        let queryArr = location.search.substring(1).split('&');
        let query = {}
        u.each(queryArr, item => {
            let tempArr = item.split('=');
            query[tempArr[0]] = tempArr[1];
        });
        this.amount = query.amount;
        this.symbol = query.symbol;
        this.isApply = query.apply === '1';
        this.blockchainId = query.blockchain_id;

        this.hintText = this.blockchainId === '3' ? '请输入您的墨客钱包地址' : '请输入您的以太坊钱包地址';
       
        moment.locale('zh-cn');
        this.contractAddress = this.$route.params.contractAddress;

        Axios.get(DOMAIN + '/v1/token_apply/list?start=0&count=100&address=' + this.contractAddress).then(res => {
            let result = res.data;
            if (result.result === 0 && result.data && result.data.length) {
                u.each(result.data, item => {
                    item.create_time = moment(item.create_time).fromNow();
                });
                this.applyList = result.data;
            }
        });
    },
    methods: {
        goGetTP() {
            document.location = 'https://www.mytokenpocket.vip/'
        },
        goGetCandy() {
            if (!this.nameValid || !this.addressVaild) {
                return;
            }
            let nick_name = this.nickName;
            let contract_address = this.contractAddress;
            let address = this.address;
            let value = 10000;
            $.post(DOMAIN + '/v1/token_apply', {nick_name, contract_address, address, value}).then(res => {
                if (res.result === 0) {
                    this.dialog = true
                }
            }); 
        },
        close() {
            this.dialog = false;
        },
        inputNickname(value) {
            if (!value) {
                this.nameValid = false;
                this.nicknameInputErrorText = '昵称不可为空';
            }
            else if (value.length > 10) {
                this.nameValid = false;
                this.nicknameInputErrorText = '昵称长度不可超过10个字符';
            }
            else {
                this.nameValid = true;
                this.nicknameInputErrorText = '';
            }
        },
        inputAddress(value) {
            if (!web3.utils.isAddress(value) || value.length != 42) {
                this.addressVaild = false;
                this.addressInputErrorText = '地址格式不正确';
            }
            else {
                this.addressVaild = true;
                this.addressInputErrorText = '';
            }
        }
    }
}
</script>

<style scoped lang="less">

    .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #070707;
        z-index: -100;
    }
    .token-share {
        margin: -15px;
        background: #070707 url('../assets/share_bg.jpg') no-repeat;
        background-size: 100% auto;
        min-height: 600px;
    }

    .apply-divider {
        font-size: 0;
        margin: 0 -20px;

        img {
            width: 100%;
        }
    }
    .applied-list-img {
        display: block;
        margin: 10px auto;
        width: 80%;
    }

    .apply-list {
        h4 {
            line-height: 36px;
        }
    }

    .mu-text-field-hint {
        background: #fff;
        border-radius: 30px;
    }

    .mu-text-field.focus-state {
        color: transparent !important;
    }

    .mu-text-field-focus-line,
    .mu-text-field-line {
        display: none !important;
    }

    .tokenpocket-link {
        padding: 10px 20px 30px;
        background: #fff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;

        p {
            margin: 10px 0;
            color: #666;
            font-size: 12px;
            font-weight: bold;
        }
    }

    .apply-time {
        float: right;
    }

    .black-btn {
        background: #211d18;
        color: #deb87f;
        border-radius: 30px;
        font-weight: bold;
        margin: 5px 0 10px;
    }

    .footer {
        min-height: 20px;
        width: 100%;
    }

    .main-content {
        margin: 10px auto 0;
        text-align: center;
        padding: 20px;
        color: #634b20;
        width: 85%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        background: #bea97b;
        background: linear-gradient(to right, #bea97b 0%,#dcc99e 100%); 

        input {
            border-radius: 20px;
            // background: #fff;
            padding-left: 20px;
        }

        .no-empty-state {
            input {
                background: #fff;
            }
        }
        a {
            font-size: 12px;
            color: #634b20;
        }
    }

    .i-want-token {
        display: block;
        width: 50%;
        margin: 0 auto;
    }

    .share-title {
        width: 100%;
        margin-top: 80px;
    }
</style>



// WEBPACK FOOTER //
// src/components/TokenShare.vue